import axios from 'axios'

import Cookie from '@/common/cookie'
import Vue from 'vue'

import Router from '@/router/index'

const { NODE_ENV } = process.env

console.log(NODE_ENV)

const ajax = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL + '/gft/',
    validateStatus (status) {
        return [200, 400, 401, 403, 422].indexOf(status) > -1
    },
    responseType: 'json'
})

ajax.interceptors.request.use((config) => {
    config.headers.Authorization = Cookie.getItem('cdfang_token')
    return config
})

ajax.interceptors.response.use((res) => {
    const { status, data } = res
    const { meta } = data
    if (status === 401) {
        Cookie.clearItems()
        window.location.hash = '#/login'
        return Promise.reject(res)
    }
    if (status === 422 || status === 500) {
        const msg = meta ? meta.error_message : '服务器错误'
        Vue.dialog.alert(msg, {
            okText: '知道了'
        }).then(dialog => {
            console.log(dialog)
        })
        return Promise.reject(res)
    }
    const { data: respData } = res
    return respData
}, (err) => {
    return Promise.reject(err)
})

const getPath = (url) => {
    const city = Router.history.current.params.city || 'cd'
    return `${city}/${url}`
}

export const get = (url, params) => {
    return ajax.get(getPath(url), { params })
}

export const post = (url, params) => {
    return ajax.post(getPath(url), params)
}

export const put = (url, params) => {
    return ajax.put(getPath(url), params)
}
